import { render, staticRenderFns } from "./GameDuration.vue?vue&type=template&id=beaa23ac&scoped=true&"
import script from "./GameDuration.vue?vue&type=script&lang=js&"
export * from "./GameDuration.vue?vue&type=script&lang=js&"
import style0 from "./GameDuration.vue?vue&type=style&index=0&id=beaa23ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaa23ac",
  null
  
)

export default component.exports